import Vue from 'vue';
import VueCookie from 'vue-cookies';
Vue.use(VueCookie);
Vue.$cookies.config('30d');

const COOKIE_NAME = 'mihStep3DefaultParams';

export default {
  namespaced: true,
  state: {
    initErrors: [],
    params: {
      roomId: (Vue.$cookies.get(COOKIE_NAME) || {roomId: -1}).roomId,
      priceId: (Vue.$cookies.get(COOKIE_NAME) || {priceId: -1}).priceId,
    }
  },
  mutations: {
    SET_INIT_ERRORS (state, payload) {
      state.initErrors = payload;
    },
    SET_PARAMS (state, params) {
      if (params === null) {
        Vue.$cookies.remove(COOKIE_NAME)
        state.params = {
          roomId: -1,
          priceId: -1
        }
      }
      state.params = params
      Vue.$cookies.set(COOKIE_NAME, params, '30d');
    }
  },
  actions: {
    async persistParams (context, {roomId, priceId}) {
      context.commit('SET_PARAMS', {roomId, priceId});
    },
    async destroyParams (context) {
      context.commit('SET_PARAMS', null);
    },
  }
}



// WEBPACK FOOTER //
// ./src/stores/booking-step3.store.js